import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { getSnowEnabled, setSnowEnabled, getSnowColorId, setSnowColorId, resolveSnowColor } from 'utils/snowfall';

type SnowSettings = {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  colorId: string;
  setColorId: (id: string) => void;
  color: string;
};

const Ctx = createContext<SnowSettings | null>(null);

const SnowSettingsProvider = ({ children }: { children: ReactNode }) => {
  const [enabled, setEnabledState] = useState(() => getSnowEnabled());
  const [colorId, setColorIdState] = useState(() => getSnowColorId());

  const setEnabled = (v: boolean) => {
    setEnabledState(v);
    setSnowEnabled(v);
  };

  const setColorId = (id: string) => {
    setColorIdState(id);
    setSnowColorId(id);
  };

  const value = useMemo(
    () => ({
      enabled,
      setEnabled,
      colorId,
      setColorId,
      color: resolveSnowColor(colorId),
    }),
    [enabled, colorId]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export default SnowSettingsProvider;

export const useSnowSettings = () => {
  const v = useContext(Ctx);

  if (!v) throw new Error('useSnowSettings must be used within SnowSettingsProvider');
  return v;
};
